// extracted by mini-css-extract-plugin
module.exports = {"price":"dece2e673c--price--rawkq"};